<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { get_noSecretLogin, login_auth } from "./api/login/api";
export default {
  name: "App",
  data() {
    return {
      para: ""
    }
  },
  created() {
    this.GetUrlPara();
  },
  // // 挂载结束状态(里面是操作)
  // mounted() {
  //   this.GetUrlPara();
  // },
  methods: {
    GetUrlPara() {
      var url = document.location.toString();
      var arrUrl = url.split("?");
      this.para = arrUrl[1] == undefined ? "" : arrUrl[1].slice(6, arrUrl[1].length);
      if (this.para != "") {
        get_noSecretLogin(this.para).then((res) => {
          if (res.code == 0) {
            window.localStorage.setItem("yypt_web_token", res.data.token);
            window.localStorage.setItem("yypt_web_sk", res.data.sk);
            localStorage.setItem("yypt_web_user", res.data.account);
            this.$store.commit("login", "true");
            this.$router.replace({ path: "/home_page/home_Page" });
            this.getAuth()
          }
        })
      }
    },
    getAuth() {
      login_auth().then((res) => {
        window.localStorage.setItem("auth_self", res.data)
        // if (res.data != "") {
        //   this.$router.push({ path: "/home_page/home_Page" });
        // }
      })
    },
  }
};
</script>

<style>
html,
body {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0px;
  margin: 0px;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  widows: 100%;
  height: 100%;
}

/* 滚动条样式 */
::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 0;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  cursor: pointer;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.25);
  transition: color 0.2s ease;
}
</style>



// WEBPACK FOOTER //
// src/App.vue